import './scss/main.scss'
import { create } from 'utilities/moduleLoader'
import { moduleMap } from './moduleMap'
import Services from 'services'
import Analytics from './js/services/Analytics/Analytics'

/**
 * Masonite App responsible for loading modules on page load
 */
export default class App {
	static SELECTORS = {
		MODULES: '[data-cmp-is]'
	}

	constructor() {
		this.modules = [] // ref to all of the instantiated module
		this.services = Services.getInstance()
		this.EventEmitterService = this.services.EventEmitterService
		this.analytics = Analytics.getInstance()
		this.loadModules()
	}

	/**
	 * Destroys all modules in the app
	 */
	destroy() {
		this.modules.forEach((module) => {
			if (typeof module.destroy === 'function') {
				module.destroy()
			}
		})
	}

	/**
	 * Queries the DOM elements modules on a page and instantiates
	 * an instance of them if they have not yet been instantiated
	 * and the associated JS module is defined
	 */
	loadModules() {
		create(moduleMap).then((modules) => {
			this.modules.push(modules)
			this.dispatchModulesLoaded()
		})
	}

	/**
	 * Dispatches a global event that modules have been loaded
	 */
	dispatchModulesLoaded() {
		this.EventEmitterService.emit(Services.EVENTS.MODULES_LOADED)
	}
}
